import React, { useEffect } from 'react';
import SEO from '../components/SEO';
import CustomHeader from '../components/CustomHeader';
import PartnersSection from '../components/PartnersSection';
import companyImg from '../company-img.jpg';
import '../App.css';

const AboutPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="subcustom-header-container">
      <SEO 
        title="제스트정보기술"
        description="오픈소스, IT인프라 소프트웨어, 성능모니터링 전문기업"
      />
      <CustomHeader />
      <header className="subcustom-header">
        <div className="hero-title-area">
          <div className="hero-subtitle">ABOUT US</div>
          <h2 className="hero-title">회사소개</h2>
        </div>
      </header>

      <main className="infra-main">
        <div className="solutions-layout about-page-layout">
          {/* 콘텐츠 영역 */}
          <div className="content-area" style={{width: '100%'}}>
            {/* 인사말 */}
            <section className="solution-section" style={{marginBottom: '40px'}}>
              <h2 className="section-title">인사말</h2>
              <div className="product-content">
                <div className="product-text">
                  <div style={{fontSize: '1.15rem', color: '#222', lineHeight: 1.7}}>
                    <p style={{marginBottom: '20px'}}>
                      안녕하십니까? (주)제스트정보기술입니다.<br/>
                      홈페이지를 방문해 주신 여러분께 환영의 말씀을 드립니다.
                    </p>
                    <p style={{marginBottom: '20px'}}>
                      (주)제스트정보기술은 고객님의 요구에 부응하는 최적의 IT솔루션을 제공하기 위해<br/>
                      노력 하고 있습니다.
                    </p>
                    <p style={{marginBottom: '20px'}}>
                      전세계적으로 자바기술(J2EE)이 서서히 뿌리내리기 시작하는 2001년에 Resin 비지니스를<br/>
                      시작으로 오픈소스, IT인프라 성능모니터링, Cloud 플랫폼 서비스 까지<br/>
                      항상 고객과 소통하며 기술의 변화에 발맞추어 함께 성장해 왔습니다.
                    </p>
                    <p style={{fontWeight: 'bold', color: '#667eea'}}>
                      오직 고객중심의 솔루션을 제안하고 최상의 서비스를 제공하겠습니다.
                    </p>
                  </div>
                </div>
                <div className="product-image">
                  <img src={companyImg} alt="회사 대표 이미지" style={{borderRadius: '18px', width: '100%', boxShadow: '0 4px 24px rgba(0,0,0,0.10)'}} />
                </div>
              </div>
            </section>

            {/* 비전 및 핵심가치 */}
            <section className="solution-section" style={{marginBottom: '40px'}}>
              <h2 className="section-title">OUR VISION</h2>
              <div className="vision-cards" style={{display:'flex', gap:'28px', flexWrap:'wrap'}}>
                <div className="vision-card" style={{flex:'1', minWidth:'180px', background:'#f7f9fc', borderRadius:'14px', padding:'24px 18px', boxShadow:'0 2px 8px rgba(102,126,234,0.07)'}}>
                  <h3 className="vision-title" style={{color:'#667eea', fontWeight:'bold', fontSize:'1.32rem'}}>고객중심</h3>
                  <p style={{marginTop:'10px'}}>고객의 성공을 최우선으로 생각하며, 신뢰와 소통을 바탕으로 함께 성장합니다.</p>
                </div>
                <div className="vision-card" style={{flex:'1', minWidth:'180px', background:'#f7f9fc', borderRadius:'14px', padding:'24px 18px', boxShadow:'0 2px 8px rgba(102,126,234,0.07)'}}>
                  <h3 className="vision-title" style={{color:'#667eea', fontWeight:'bold', fontSize:'1.32rem'}}>기술혁신</h3>
                  <p style={{marginTop:'10px'}}>최신 IT 트렌드와 기술을 선도하며, 끊임없는 연구와 혁신으로 최고의 솔루션을 제공합니다.</p>
                </div>
                <div className="vision-card" style={{flex:'1', minWidth:'180px', background:'#f7f9fc', borderRadius:'14px', padding:'24px 18px', boxShadow:'0 2px 8px rgba(102,126,234,0.07)'}}>
                  <h3 className="vision-title" style={{color:'#667eea', fontWeight:'bold', fontSize:'1.32rem'}}>미래지향</h3>
                  <p style={{marginTop:'10px'}}>지속가능한 성장과 미래가치 창출을 위해 고객과 함께 나아갑니다.</p>
                </div>
              </div>
            </section>

            {/* 연혁 */}
            <section className="solution-section" style={{marginBottom: '40px'}}>
              <h2 className="section-title">주요 연혁</h2>
              <div className="timeline-container" style={{
                position: 'relative',
                padding: '60px 20px',
                marginTop: '40px'
              }}>
                {/* 타임라인 아이템들 */}
                <div className="timeline-items" style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start',
                  position: 'relative',
                  gap: '30px'
                }}>
                  {/* 2004-2015 */}
                  <div className="timeline-item" style={{flex: 1, textAlign: 'center'}}>
                    <div className="timeline-node" style={{
                      width: '90px',
                      height: '90px',
                      borderRadius: '50%',
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: '0 auto 30px',
                      boxShadow: '0 10px 30px rgba(102, 126, 234, 0.3)',
                      color: 'white',
                      fontSize: '15px',
                      fontWeight: '600',
                      position: 'relative',
                      zIndex: 3
                    }}>
                      <span style={{lineHeight: '1.2'}}>2004</span>
                      <span style={{lineHeight: '1.2'}}>2015</span>
                    </div>
                    <div className="timeline-content" style={{
                      padding: '0 10px'
                    }}>
                      <ul style={{
                        listStyle: 'none',
                        padding: 0,
                        margin: 0,
                        fontSize: '14px',
                        lineHeight: 1.7,
                        color: '#444'
                      }}>
                        <li style={{marginBottom: '12px', position: 'relative', paddingLeft: '18px'}}>
                          <span style={{
                            position: 'absolute',
                            left: 0,
                            top: '8px',
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            background: '#667eea'
                          }}></span>
                          Resin GS인증 획득
                        </li>
                        <li style={{marginBottom: '12px', position: 'relative', paddingLeft: '18px'}}>
                          <span style={{
                            position: 'absolute',
                            left: 0,
                            top: '8px',
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            background: '#667eea'
                          }}></span>
                          Resin 솔루션 국내 독점 공급
                        </li>
                        <li style={{marginBottom: '12px', position: 'relative', paddingLeft: '18px'}}>
                          <span style={{
                            position: 'absolute',
                            left: 0,
                            top: '8px',
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            background: '#667eea'
                          }}></span>
                          제니퍼소프트 공식 파트너 계약
                        </li>
                      </ul>
                    </div>
                  </div>

                  {/* 2016-2018 */}
                  <div className="timeline-item" style={{flex: 1, textAlign: 'center'}}>
                    <div className="timeline-node" style={{
                      width: '90px',
                      height: '90px',
                      borderRadius: '50%',
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: '0 auto 30px',
                      boxShadow: '0 10px 30px rgba(102, 126, 234, 0.3)',
                      color: 'white',
                      fontSize: '15px',
                      fontWeight: '600',
                      position: 'relative',
                      zIndex: 3
                    }}>
                      <span style={{lineHeight: '1.2'}}>2016</span>
                      <span style={{lineHeight: '1.2'}}>2018</span>
                    </div>
                    <div className="timeline-content" style={{
                      padding: '0 10px'
                    }}>
                      <ul style={{
                        listStyle: 'none',
                        padding: 0,
                        margin: 0,
                        fontSize: '14px',
                        lineHeight: 1.7,
                        color: '#444'
                      }}>
                        <li style={{marginBottom: '12px', position: 'relative', paddingLeft: '18px'}}>
                          <span style={{
                            position: 'absolute',
                            left: 0,
                            top: '8px',
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            background: '#667eea'
                          }}></span>
                          가비아 Cloud Partner 계약
                        </li>
                        <li style={{marginBottom: '12px', position: 'relative', paddingLeft: '18px'}}>
                          <span style={{
                            position: 'absolute',
                            left: 0,
                            top: '8px',
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            background: '#667eea'
                          }}></span>
                          전자정부프레임웍 호환성 인증
                        </li>
                      </ul>
                    </div>
                  </div>

                  {/* 2019-2024 */}
                  <div className="timeline-item" style={{flex: 1, textAlign: 'center'}}>
                    <div className="timeline-node" style={{
                      width: '90px',
                      height: '90px',
                      borderRadius: '50%',
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: '0 auto 30px',
                      boxShadow: '0 10px 30px rgba(102, 126, 234, 0.3)',
                      color: 'white',
                      fontSize: '15px',
                      fontWeight: '600',
                      position: 'relative',
                      zIndex: 3
                    }}>
                      <span style={{lineHeight: '1.2'}}>2019</span>
                      <span style={{lineHeight: '1.2'}}>2024</span>
                    </div>
                    <div className="timeline-content" style={{
                      padding: '0 10px'
                    }}>
                      <ul style={{
                        listStyle: 'none',
                        padding: 0,
                        margin: 0,
                        fontSize: '14px',
                        lineHeight: 1.7,
                        color: '#444'
                      }}>
                        <li style={{marginBottom: '12px', position: 'relative', paddingLeft: '18px'}}>
                          <span style={{
                            position: 'absolute',
                            left: 0,
                            top: '8px',
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            background: '#667eea'
                          }}></span>
                          RedHat 공식 Partner 계약
                        </li>
                        <li style={{marginBottom: '12px', position: 'relative', paddingLeft: '18px'}}>
                          <span style={{
                            position: 'absolute',
                            left: 0,
                            top: '8px',
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            background: '#667eea'
                          }}></span>
                          엑셀 MaxGauge 사업제휴
                        </li>
                        <li style={{marginBottom: '12px', position: 'relative', paddingLeft: '18px'}}>
                          <span style={{
                            position: 'absolute',
                            left: 0,
                            top: '8px',
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            background: '#667eea'
                          }}></span>
                          두썸소프트 TAMIS 총판 계약
                        </li>
                        <li style={{marginBottom: '12px', position: 'relative', paddingLeft: '18px'}}>
                          <span style={{
                            position: 'absolute',
                            left: 0,
                            top: '8px',
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            background: '#667eea'
                          }}></span>
                          1200+ 누적 고객수 달성
                        </li>
                        <li style={{marginBottom: '12px', position: 'relative', paddingLeft: '18px'}}>
                          <span style={{
                            position: 'absolute',
                            left: 0,
                            top: '8px',
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            background: '#667eea'
                          }}></span>
                          오픈소스 기술지원 서비스 개시
                        </li>
                        <li style={{marginBottom: '12px', position: 'relative', paddingLeft: '18px'}}>
                          <span style={{
                            position: 'absolute',
                            left: 0,
                            top: '8px',
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            background: '#667eea'
                          }}></span>
                          조달청 디지털서비스몰 Resin 등록
                        </li>
                        <li style={{marginBottom: '12px', position: 'relative', paddingLeft: '18px'}}>
                          <span style={{
                            position: 'absolute',
                            left: 0,
                            top: '8px',
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            background: '#667eea'
                          }}></span>
                          가산동 에이스가산타워 사옥 마련
                        </li>
                      </ul>
                    </div>
                  </div>

                  {/* 2025 */}
                  <div className="timeline-item" style={{flex: 1, textAlign: 'center'}}>
                    <div className="timeline-node" style={{
                      width: '90px',
                      height: '90px',
                      borderRadius: '50%',
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: '0 auto 30px',
                      boxShadow: '0 10px 30px rgba(102, 126, 234, 0.3)',
                      color: 'white',
                      fontSize: '15px',
                      fontWeight: '600',
                      position: 'relative',
                      zIndex: 3
                    }}>
                      <span style={{lineHeight: '1.2'}}>2025</span>
                    </div>
                    <div className="timeline-content" style={{
                      padding: '0 10px'
                    }}>
                      <ul style={{
                        listStyle: 'none',
                        padding: 0,
                        margin: 0,
                        fontSize: '14px',
                        lineHeight: 1.7,
                        color: '#444'
                      }}>
                        <li style={{marginBottom: '12px', position: 'relative', paddingLeft: '18px'}}>
                          <span style={{
                            position: 'absolute',
                            left: 0,
                            top: '8px',
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            background: '#667eea'
                          }}></span>
                          이지이노베이션 eG Enterprise 솔루션 공식 Partner 계약
                        </li>
                        <li style={{marginBottom: '12px', position: 'relative', paddingLeft: '18px'}}>
                          <span style={{
                            position: 'absolute',
                            left: 0,
                            top: '8px',
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            background: '#667eea'
                          }}></span>
                          오픈소스 DBMS 지원팀 확장
                        </li>
                        <li style={{marginBottom: '12px', position: 'relative', paddingLeft: '18px'}}>
                          <span style={{
                            position: 'absolute',
                            left: 0,
                            top: '8px',
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            background: '#667eea'
                          }}></span>
                          LG CNS 솔루션 사업부 Award for Partner Excellence 2024 수상
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <PartnersSection />

            {/* 오시는길 */}
            <section className="solution-section" style={{marginBottom: '40px'}}>
              <h2 className="section-title">오시는길</h2>
              <div className="map-wrap" style={{margin: '18px auto 0', maxWidth: '1200px'}}>
                <iframe 
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d25331.72689228166!2d126.87761016053344!3d37.47333154295277!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357b61e4c03e2569%3A0xfbe1f939d1277e7e!2z7JeQ7J207Iqk6rCA7IKw7YOA7JuM!5e0!3m2!1sko!2skr!4v1752656976769!5m2!1sko!2skr" 
                  width="100%" 
                  height="500" 
                  style={{border:0, display:'block', borderRadius: '14px'}} 
                  allowFullScreen="" 
                  loading="lazy" 
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </section>

            {/* 연락처 정보 */}
            <section className="contact-info-section" style={{marginBottom: '40px'}}>
              <div className="contact-info-container">
                <div className="contact-info-item">
                  <div className="contact-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3 5C3 3.89543 3.89543 3 5 3H8.27924C8.70967 3 9.09181 3.27543 9.22792 3.68377L10.7257 8.17721C10.8831 8.64932 10.6694 9.16531 10.2243 9.38787L7.96701 10.5165C9.06925 12.9612 11.0388 14.9308 13.4835 16.033L14.6121 13.7757C14.8347 13.3306 15.3507 13.1169 15.8228 13.2743L20.3162 14.7721C20.7246 14.9082 21 15.2903 21 15.7208V19C21 20.1046 20.1046 21 19 21H18C9.71573 21 3 14.2843 3 6V5Z" fill="#1a365d"/>
                    </svg>
                  </div>
                  <div className="contact-text">
                    <div className="contact-primary">Call: +02-558-5918</div>
                    <div className="contact-secondary">Monday-Friday(10am-7pm)</div>
                  </div>
                </div>

                <div className="contact-info-item">
                  <div className="contact-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3 8L10.89 13.26C11.2187 13.4793 11.6049 13.5963 12 13.5963C12.3951 13.5963 12.7813 13.4793 13.11 13.26L21 8M5 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19Z" fill="#1a365d"/>
                    </svg>
                  </div>
                  <div className="contact-text">
                    <div className="contact-primary">sales@xest.kr</div>
                    <div className="contact-secondary">Web: <a href="http://www.xest.kr" target="_blank" rel="noopener noreferrer" style={{color: 'inherit', textDecoration: 'none'}}>www.xest.kr</a></div>
                  </div>
                </div>

                <div className="contact-info-item">
                  <div className="contact-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21 10C21 17 12 23 12 23S3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z" fill="#1a365d"/>
                      <path d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z" fill="white"/>
                    </svg>
                  </div>
                  <div className="contact-text">
                    <div className="contact-primary">우 08505 서울특별시 금천시 디지털로 121</div>
                    <div className="contact-secondary">에이스가산타워 7층 703호</div>
                  </div>
                </div>
              </div>
            </section>

            {/* 회사 정보 및 연락처 */}
            <section className="solution-section">
              <h2 className="section-title">회사 정보 및 연락처</h2>
              <div className="info-grid" style={{display:'flex', flexWrap:'wrap', gap:'32px', alignItems:'flex-start', marginTop:'18px'}}>
                <ul className="info-list" style={{flex:'2', minWidth:'220px', fontSize:'1.08rem', color:'#222', lineHeight:1.8, paddingLeft:0}}>
                  <li><b>회사명</b> : (주)제스트정보기술</li>
                  <li><b>대표자</b> : 임항순</li>
                  <li><b>설립일</b> : 2004년 11월 03일</li>
                  <li><b>사업분야</b> : IT인프라 솔루션, 오픈소스, IT성능모니터링, DBMS컨설팅</li>
                  <li><b>소재지</b> : 서울특별시 금천구 디지털로 121, 7층 703호(가산동, 에이스가산타워)</li>
                  <li><b>전화</b> : 02-558-5918(代)</li>
                  <li><b>FAX</b> : 02-558-5913</li>
                  <li><b>홈페이지</b> : <a href="http://www.xest.kr" target="_blank" rel="noopener noreferrer">www.xest.kr</a></li>
                </ul>
              </div>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AboutPage; 